module.exports = __webpack_public_path__ + "img/button_save.8595be1d.png";